import React, { useEffect, useState , useCallback} from 'react';
import { Button, Col, Form, FormControl, InputGroup, Row } from 'react-bootstrap';
import axios from 'axios';
import { host, url } from '../../../config/common';
import Loader from '../../utils/loader';
import CustomPagination from './pagination/customPagination';
import SocialContentCreateModal from '../../utils/socialMediaManage/socialContentCreateModal';
import SocialContentManageCard from '../../utils/socialMediaManage/socialContentManageCard';
import { useSelector } from 'react-redux';

const SocialContentManage = ({ navigate }) => {
    const airportData = useSelector((state) => state.airports.data);
    const [searchInput, setSearchInput] = useState("");
    const [showEdit, setShowEdit] = useState(false);
    const [socialContentData, setSocialContentData] = useState({
        list: [],
        loading: false,
        currentPage: "1",
        totalPages: 1,
        totalRecords: 1,
    });
    const [socialParams, setSocialParams] = useState({
        page: 1,
        limit: 21,
    });
    const [showloader, setShowloader] = useState(false);

    const fetchSocialMediaContent = async () => {
        try {
            setShowloader(true);
            let fetchedEventData = await axios({
                method: 'get',
                headers: { 'x-access-token': JSON.parse(localStorage.getItem('user'))?.token ? JSON.parse(localStorage.getItem('user')).token : "" },
                url: `${host}${url.getSocialMediaContent}?search=${searchInput}&page=${socialParams.page}&limit=${socialParams.limit}`
            });
            if (fetchedEventData?.status == 401) {
                localStorage.removeItem("user")
                return navigate("/")
            }
            if (fetchedEventData) {
                setShowloader(false);
                setSocialContentData((v) => ({
                    ...v,
                    list: fetchedEventData?.data?.data?.records,
                    loading: false,
                    currentPage: fetchedEventData?.data?.data?.currentPage,
                    totalPages: fetchedEventData?.data?.data?.totalPages,
                    totalRecords: fetchedEventData?.data?.data?.totalRecords,
                }));
            }
        } catch (error) {
            console.log({ error });
            if (error?.response?.status == 401) {
                localStorage.removeItem("user")
                return navigate("/")
            }
        }
    }

    const searchContent = async (e) => {
        try {
            fetchSocialMediaContent();
        } catch (error) {
            console.log({ error });
        }
    }

    const handlePageChange = (e, page) => {
        setSocialParams((v) => ({ ...v, page: page }));
    };

    const paginationProps = {
        currentPage: socialContentData?.currentPage,
        totalPages: socialContentData?.totalPages,
        totalRecords: socialContentData?.totalRecords,
        handlePageChange,
    };

    const handleClose = () => {
        setShowEdit(false)
    }

    useEffect(() => {
        fetchSocialMediaContent();
    }, [socialParams]);

    return (
        <div style={{ padding: "0px 20px" }}>
            <SocialContentCreateModal show={showEdit} handleClose={handleClose} refreshData={() => fetchSocialMediaContent()} airportList={airportData}/>
            <Row>
                <Col>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <h3>Social Media Content Management</h3>
                        <Button variant='outline-primary' onClick={() => setShowEdit(true)} >Add Social Media</Button>
                    </div>
                </Col>
            </Row>
            <Row>
                <div>
                    <Row>
                        <Col xs="7">
                            <Form onSubmit={(e) => { e.preventDefault(); searchContent() }}>
                                <InputGroup style={{ width: "500px", float: "left", marginBottom: "1%" }}>
                                    <FormControl
                                        placeholder="Search by airport ID, platform"
                                        onChange={(e) => setSearchInput(e.target.value)}
                                        value={searchInput}
                                    />
                                    <Button variant="outline-primary" type='submit'>
                                        Search
                                    </Button>
                                </InputGroup>
                            </Form>
                        </Col>
                    </Row>
                    <Loader show={showloader} />
                    <Row style={{ height: "82vh", overflow: "scroll " }}>
                        <Col>
                            {socialContentData?.list?.length > 0
                                ?
                                <>
                                    <Row style={{ marginTop: "20px" }}>
                                        {
                                            socialContentData?.list?.map((item) =>
                                                <Col sm="4" key={item._id}>
                                                    <SocialContentManageCard socialContentData={item} refreshData={() => fetchSocialMediaContent()} airportList={airportData} />
                                                </Col>
                                            )
                                        }
                                    </Row>
                                    <CustomPagination props={{ paginationProps }} />
                                </>
                                :
                                <Row style={{ marginTop: "20px" }}>No Records Found</Row>
                            }

                        </Col>
                    </Row>
                </div>
            </Row>
        </div>
    );
}

export default SocialContentManage;
